import { ADD_PRODUCT_TO_CART, UPDATE_IS_CART } from '@store/officialStore/cart';
import {
  UPDATE_SHOW_DETAIL_POPUP_DATA,
  CLOSE_DETAIL_POPUP
} from '@store/officialStore/index';
import { mapState, mapGetters } from 'vuex';
import { deviceDirectionPortrait } from '@utiles/officialStore/device';
import { ERROR_TYPE, errorReport } from '@utiles/errorReport';
export default {
  props: {
    showDetailPopupBtn: {
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      cartQuantityLimit: state => state.cart.cartQuantityLimit
    }),
    ...mapGetters(['cartTotalQuantity'])
  },
  methods: {
    handleSingleProductLimit(item) {
      this.$globalTip({
        title: this.letter.tips,
        content: `${this.letter.limit_buy_product.replace('${n}', item.LIMIT)}`,
        confirm: this.letter.onestore_subscribe_confirm
      });
    },
    handleTotalProductLimit() {
      this.$globalTip({
        title: this.letter.tips,
        content: `${this.letter.limit_order.replace(
          '${n}',
          this.cartQuantityLimit
        )}`,
        confirm: this.letter.onestore_subscribe_confirm
      });
    },
    handleProductPriceError(item) {
      this.$globalTip({
        title: this.letter.tips,
        content: this.letter.fail_and_later,
        confirm: this.letter.onestore_subscribe_confirm
      });
      errorReport(ERROR_TYPE.POPUP_MATCH_CART_PRODUCT_LEVEL_FAIL, {
        productId: item?.PRODUCT_ID,
        cpProductId: item?.CP_PRODUCT_ID,
        amountLevel: item?.amountLevel
      });
    },
    addToCart(event, item, barColor = '#c79532', showBar = true) {
      window.webstorev1DataLayer.push({
        eventName: 'select_product',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: item.CP_PRODUCT_ID || '',
          product_id: item.PRODUCT_ID || '',
          product_num: 1,
          product_currency: item.CURRENCY || '',
          product_money: item.GAME_AMOUNT || ''
        }
      });
      const errorHandle = {
        singleProductLimit: 'handleSingleProductLimit',
        totalProductLimit: 'handleTotalProductLimit',
        productPriceError: 'handleProductPriceError'
      };

      if (+item.quantity >= +item.LIMIT) {
        this[errorHandle.singleProductLimit](item);
        return;
      }
      if (this.cartTotalQuantity + 1 > this.cartQuantityLimit) {
        this[errorHandle.totalProductLimit]();
        return;
      }
      if (
        !item.amountLevel ||
        !item.amountLevel?.TRANS_AMOUNT ||
        !item.amountLevel?.SHOW_CURRENCY
      ) {
        this[errorHandle.productPriceError](item);
        return;
      }
      this.doAddToCart(event, item, barColor, showBar);
    },
    doAddToCart(event, item, barColor, showBar) {
      this.$store.commit(ADD_PRODUCT_TO_CART, item);
      this.$store.commit(UPDATE_IS_CART, true);
      if (showBar) {
        this.animateToCartBar(event, barColor);
        return;
      }
      this.$store.commit(CLOSE_DETAIL_POPUP);
    },
    animateToCartBar(event, barColor) {
      let target = event.target.getBoundingClientRect();
      let bar = document.createElement('div');
      bar.style.position = 'fixed';
      bar.style.left = target.left + 'px';
      bar.style.top = target.top + 'px';
      bar.style.width = deviceDirectionPortrait() ? '40px' : '20px';
      bar.style.height = deviceDirectionPortrait() ? '40px' : '20px';
      bar.style.borderRadius = '50%';
      bar.style.backgroundColor = barColor;
      bar.style.zIndex = '1';
      bar.style.transition =
        'left .3s linear, top .3s cubic-bezier(0.5, -0.5, 1, 1)';
      document.body.appendChild(bar);
      setTimeout(() => {
        let ntarget = document
          .querySelector('#cartDetailContainer')
          .getBoundingClientRect();
        bar.style.left = ntarget.left + 20 + 'px';
        bar.style.top = ntarget.top + 20 + 'px';
        this.$store.commit(CLOSE_DETAIL_POPUP);
        setTimeout(() => {
          document.body.removeChild(bar);
        }, 300);
      }, 0);
    },
    handleProductDetail(item) {
      this.$store.commit(UPDATE_SHOW_DETAIL_POPUP_DATA, {
        item,
        showBtn: this.showDetailPopupBtn,
        show: true
      });
    }
  }
};
